<div class="teacher-time-stop-dialog">
  <div class="teacher-time-stop-dialog__title">
    Willst du wirklich den Gametimer stoppen?
  </div>

  <div class="teacher-time-stop-dialog__timer-wrapper">
    <div class="teacher-time-stop-dialog__timer-number">
      <span class="teacher-time-stop-dialog__timer-number-background">8</span>
      <span class="teacher-time-stop-dialog__timer-number-current">{{currentLabel[0]}}</span>
    </div>
    <div class="teacher-time-stop-dialog__timer-number">
      <span class="teacher-time-stop-dialog__timer-number-background">8</span>
      <span class="teacher-time-stop-dialog__timer-number-current">{{currentLabel[1]}}</span>
    </div>
    <div class="teacher-time-stop-dialog__timer-separator">{{currentLabel[2]}}</div>
    <div class="teacher-time-stop-dialog__timer-number">
      <span class="teacher-time-stop-dialog__timer-number-background">8</span>
      <span class="teacher-time-stop-dialog__timer-number-current">{{currentLabel[3]}}</span>
    </div>
    <div class="teacher-time-stop-dialog__timer-number">
      <span class="teacher-time-stop-dialog__timer-number-background">8</span>
      <span class="teacher-time-stop-dialog__timer-number-current">{{currentLabel[4]}}</span>
    </div>
  </div>
</div>
